"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("./api");
var config_1 = __importStar(require("../config"));
var getSection_1 = __importDefault(require("./queries/getSection"));
var Rails_1 = require("./Rails");
var selectors_1 = require("../modules/devices/selectors");
exports.getActions = function (namespace, railSelector) {
    var fetchContent = function (_a) {
        var initialRailSize = _a.initialRailSize, appId = _a.appId;
        return function (dispatch, getState) {
            var deviceId = selectors_1.getSerialNumber(getState());
            return dispatch(api_1.createApiAction(namespace + "/FETCH_CONTENT", {
                baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
                params: {
                    query: getSection_1.default(namespace.toLowerCase(), initialRailSize),
                    variables: { appId: appId, deviceId: deviceId },
                },
                authenticated: true,
                graphQL: true,
            }));
        };
    };
    var fetchRailById = function (railId, sectionId, appId, nextPageSize) { return function (dispatch, getState) {
        var _a;
        var deviceId = selectors_1.getSerialNumber(getState());
        var railInfo = railSelector(getState())(railId);
        var endCursor = (_a = railInfo === null || railInfo === void 0 ? void 0 : railInfo.contentPage.pageInfo) === null || _a === void 0 ? void 0 : _a.endCursor;
        return dispatch(Rails_1.createFetchRailAction(namespace + "/FETCH_RAIL", railId, endCursor, sectionId, appId, deviceId, nextPageSize));
    }; };
    return {
        fetchContent: fetchContent,
        fetchRailById: fetchRailById,
    };
};
exports.getReducers = function (namespace, reducerMap) {
    return {
        content: api_1.createCustomModuleReducer(__assign(__assign(__assign({}, api_1.createApiReducer({
            actionType: namespace + "/FETCH_CONTENT",
            onSuccess: api_1.createApiOnSuccessReducer(function (_, action) {
                var _a;
                var rails = (_a = action.payload.experience.section) === null || _a === void 0 ? void 0 : _a.home.groups;
                return {
                    rails: rails,
                };
            }),
        })), Rails_1.createRailReducer(namespace + "/FETCH_RAIL")), reducerMap), api_1.createApiInitialState({ rails: [] })),
    };
};
//# sourceMappingURL=Section.js.map